import { render } from "./RightsownerAdvantages.vue?vue&type=template&id=6fdb61c6&scoped=true"
const script = {}

import "./RightsownerAdvantages.vue?vue&type=style&index=0&id=6fdb61c6&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdb61c6"]])

export default __exports__